var Constants = (function () {
    return {
        HOST_WEBSITE : '3d-sofa',//3d-sofa or ddn
        SCENE_BG_COLOR_AT_LOADING : '#ffffff',
        SCENE_BG_COLOR_AFTER_LOADING : '#f3f3f3',
        ON_REDRAW_ALL_TEXTURES : 'onRedrawAllTextures',
        ON_DRAG_TEXTURE_END : 'onDragTextureEnd',
        ON_DRAG_TEXTURE : 'onDragTexture',
        ARMREST : 'armrest',
        THREADS : 'threads',
        THREADS_1 : 'threads_1',
        THREADS_2 : 'threads_2',
        LABEL : 'label',
        SUPPORT : 'support',
        DIMMENSIONS_RATIO : 1.67,
        TWIST_WAIT_TIME : 2000, //has to be changed to 2000
    }
})();
export default Constants;
